import React from 'react';
import { cn } from 'lib/utils';

interface SettingRowProps {
  label: React.ReactNode;
  description?: React.ReactNode;
  htmlFor?: string;
  /** Render the control full-width beneath the label instead of inline-right. */
  stacked?: boolean;
  children: React.ReactNode;
  className?: string;
}

/** The shared building block for every section of the merged Settings page. */
export const SettingRow: React.FC<SettingRowProps> = ({
  label,
  description,
  htmlFor,
  stacked = false,
  children,
  className,
}) => {
  const labelBlock = (
    <div className="min-w-0">
      <label htmlFor={htmlFor} className="block text-sm font-medium text-foreground">
        {label}
      </label>
      {description && <p className="mt-0.5 text-xs leading-relaxed text-muted-foreground">{description}</p>}
    </div>
  );

  if (stacked) {
    return (
      <div className={cn('space-y-2 border-b border-border py-4 last:border-0', className)}>
        {labelBlock}
        {children}
      </div>
    );
  }

  return (
    <div className={cn('flex items-start justify-between gap-4 border-b border-border py-4 last:border-0', className)}>
      {labelBlock}
      <div className="shrink-0">{children}</div>
    </div>
  );
};

export default SettingRow;
